import { ManualEventType } from '../codegen/graphql';

/**
 * The backend offers ASSET_DELETE wherever ASSET_REMOVE is offered — including
 * for parked assets, where committing it would backfill a synthetic
 * ASSET_INSTALL/ASSET_REMOVE pair into the audit trail. Parked assets are
 * deleted via deleteInstalledBaseNode (tree options menu) instead, so the
 * event surfaces only offer ASSET_DELETE for an installed asset.
 */
export const filterAvailableEvents = (
    events: ManualEventType[],
    isInstalled: boolean | undefined | null,
): ManualEventType[] =>
    isInstalled === true ? events : events.filter((e) => e !== ManualEventType.ASSET_DELETE);
